// extracted by mini-css-extract-plugin
module.exports = {"q46qjlq":"q46qjlq"};